import React from 'react'
import { connect } from 'react-redux'
import { withStyles, createStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = createStyles({
  progress: {
    position: 'absolute',
    color: '#e20015',
    top: '50%',
    left: '50%',
  },
})

const _CircularProgress = ({ classes, loaderShown }) => {
  if (!loaderShown) return null
  return (
    <div
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1000,
      }}
    >
      <CircularProgress className={classes.progress} size={75} thickness={8} />
    </div>
  )
}

const mapStateToProps = ({ loader: { loaderShown } }) => ({
  loaderShown,
})

export default React.memo(connect(mapStateToProps)(withStyles(styles)(_CircularProgress)))
